import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { isNullOrUndefined } from 'util';

import { WindowRef } from '../window-ref';

interface Ev {
	channel: string;
	data: any;
}

export const ByChannel = (channel: string) => (ev: Ev) => ev.channel === channel;

@Injectable()
export class BroadcastChannelService {
	private _channels = {};
	private _messages: Subject<Ev> = new Subject<Ev>();

	public messages$: Observable<Ev> = this._messages.asObservable();

	public constructor(private _window: WindowRef) {}

	public create(name: string) {
		if (!isNullOrUndefined(this._channels[name])) {
			return this._channels[name];
		}

		if (!this._window.nativeWindow['BroadcastChannel']) {
			return null;
		}

		// our typescript version does not have definitions for BroadcastChannel
		const ch = new this._window.nativeWindow['BroadcastChannel'](name);
		ch.onmessage = e => this._messages.next({channel: name, data: e.data || null});

		this._channels[name] = ch;

		return ch;
	}

	public subscribe(channelName: string, next?: (e: Ev) => void, e?: (e: any) => void, complete?: () => void) {
		this.create(channelName);
		this.messages$.subscribe(next, e, complete);
	}

	public postMessage(channelName: string, data: any) {
		const ch = this.create(channelName);
		ch.postMessage(data);

		return this;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/broadcast-channel/broadcast-channel.service.ts